import { ReactNode } from 'react';

export default function MainContainer({ children }: { children: ReactNode }) {
  return (
    <div className="main-container" style={{ width: '100%', position: 'relative' }}>
      {children}
    </div>
  );
}